import { flightInfoGetFlightStatusesSuccess } from '@actions/flight-info.action';
import { N0FlightStatusResult } from '@models/responses/flight-status.model';
import { Action, createReducer, on } from '@ngrx/store';

export interface State {
  flightStatusSearchResults: N0FlightStatusResult[];
}

export const INITIAL_STATE: State = {
  flightStatusSearchResults: [],
};

const reducer = createReducer(
  INITIAL_STATE,
  on(
    flightInfoGetFlightStatusesSuccess,
    (state, action): State => ({
      ...state,
      flightStatusSearchResults: action.results,
    }),
  ),
);

export const flightInfoReducer = (state: State, action: Action): State =>
  reducer(state, action);
